import React, { useEffect } from "react";

import Input from "../../../forms/Input";

const CampaignAktionscode = ({ value, onRender }) => {
    useEffect(() => {
        onRender();
    }, []);

    return (
        <Input
            placeholder="Aktionscode"
            name="aktionscode"
            onChange={
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                () => {}
            }
            value={value}
        />
    );
};

export default CampaignAktionscode;
